
const filters = document.getElementById("faq-filters");
const allheadings = document.querySelectorAll(".accordion-title");

allheadings.forEach(heading => {
const titleText = heading.textContent;

filters.innerHTML += '<a id="'+ titleText +'" class="filter-link pb-1 border-transparent border-b cursor-pointer hover:border-primary mr-7 transition-all ease-in-out duration-300">'+ titleText +'</a>';
});

const filterLink = document.querySelectorAll('.filter-link');
const elements = document.querySelectorAll(".accordion");
const firstElement = elements[0];
const firstLink = filterLink[0];

elements.forEach(element => {
    element.style.display = "none";
    });

firstElement.style.display = "flex";
firstLink.classList.remove("border-transparent")
firstLink.classList.add("border-primary")

filterLink.forEach(link => {
link.addEventListener("click", function() {
    filterLink.forEach(link => {
        link.classList.remove("border-primary");
        link.classList.add("border-transparent");
        });
    elements.forEach(element => {
    element.style.display = "none";
    if (element.id === link.id) {
        element.style.display = "flex";
        link.classList.remove("border-transparent");
        link.classList.add("border-primary");
    }
    });
});
});


